import {Typography} from "@mui/material";
import {useLocation} from "react-router-dom";
import Page from "../Components/Page";
import Preloader from "../Components/Preloader";
import ArticleCard from "../Components/ArticleCard";
import {useArticles} from "../Util/useArticles";
import {SectionType, Subject} from "../Util/constants";
import {capitalise} from "../Util/util";

// Shared listing for a single subject under a section, e.g. /learn/biology or
// /news/physics. Same component as the section landing — type and subject come
// from the route.
export default function SubjectPage() {
    const location = useLocation();
    const parts = location.pathname.split("/");
    const type = (parts[1] || "news") as SectionType;
    const subject = parts[2] as Subject;

    const articles = useArticles(type, subject);

    if (!articles) return <Page><Preloader visible size="60px"/></Page>;

    const [featured, ...rest] = articles;

    return (
        <Page
            metaTitle={`${capitalise(subject)} ${capitalise(type)} | Scimos`}
            title={capitalise(subject)}
            subtitle={capitalise(type)}
            titleUnderline
            grid
        >
            {articles.length === 0 && <Typography sx={{p: 4, opacity: 0.7}}>No {type} articles here yet.</Typography>}
            {featured && <ArticleCard grid xs={12} article={featured} variant={"featured"}/>}
            {rest.map((article) => <ArticleCard key={article.id} grid xs={12} sm={6} article={article} variant={"row"}/>)}
        </Page>
    );
}
